module.exports = __webpack_public_path__ + "static/media/Profile_2.78fd3950.svg";